<script>
  import ReferAFriend from "@/components/widgets/refer-a-friend";
  import InviteUserModal from "@/components/InviteUserModal";
  import { mapState } from 'vuex';

  /**
  * Nav-bar Component
  */
  export default {
    components: { ReferAFriend, InviteUserModal },
    data(){
      return {
        showInviteModal: false,
      }
    },
    methods: {
      toggleMenu() {
        this.$parent.toggleMenu();
      },
      toggleRightSidebar() {
        this.$parent.toggleRightSidebar();
      },
      initFullScreen() {
        document.body.classList.toggle("fullscreen-enable");
        if (
          !document.fullscreenElement &&
          /* alternative standard method */ !document.mozFullScreenElement &&
          !document.webkitFullscreenElement
        ) {
          // current working methods
          if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen();
          } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
          } else if (document.documentElement.webkitRequestFullscreen) {
            document.documentElement.webkitRequestFullscreen(
              Element.ALLOW_KEYBOARD_INPUT
            );
          }
        } else {
          if (document.cancelFullScreen) {
            document.cancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          }
        }
      },
      openInviteModal() {
        this.showInviteModal = true;
      },
      closeInviteModal() {
        this.showInviteModal = false;
      }
    },
    computed: {
      ...mapState("auth", ["user"]),
    },
  };
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex brand">
        <!-- LOGO -->
        <div class="navbar-brand-box bg-white">
          <router-link to="/" class="logo logo-light d-flex flex-row">
            <span class="logo-sm">
              <img src="@/assets/images/mpv-logo-small.png" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/mpv-logo.png" alt height="80" />
            </span>
          </router-link>
        </div>

        <!-- <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button> -->
      </div>

      <h2 class="site-header">Property Inventory Portfolio Services</h2>

      <ReferAFriend referralAmount="$25" />

      <div class="d-flex">
        <b-dropdown
          class="d-inline-block d-lg-none ms-2"
          variant="black"
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                type="text"
                class="form-control"
                placeholder="Search ..."
                aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>

        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>

        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          menu-class="dropdown-menu-end"
        >
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user"
              src="@/assets/images/users/generic-user-icon-19.jpg"
              alt="Header Avatar"
            />
            <span class="d-none d-xl-inline-block ms-1">
              <div v-if="user">
                {{user.firstName}} {{user.lastName}} ({{user.role.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}})
              </div>
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <b-dropdown-item>
            <router-link to="/profile" v-slot="{ navigate }" custom>
              <span @click="navigate" @keypress.enter="navigate">
                <i class="bx bx-user font-size-16 align-middle me-1"></i>
                {{ user.firstName }}
              </span>
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item >
             <router-link to="/account" custom>
            <i class="bx bx-wrench font-size-16 align-middle me-1"></i>
            {{ $t("navbar.dropdown.user.list.settings") }}
             </router-link>
          </b-dropdown-item>
          <b-dropdown-item v-if="$can('invite', 'User')">
            <span @click="openInviteModal">
              <i class="bx bx-user-plus font-size-16 align-middle me-1"></i>
              Add New User
            </span>
          </b-dropdown-item>
          <a href="/logout" class="dropdown-item text-danger">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            {{ $t("navbar.dropdown.user.list.logout") }}
          </a>
        </b-dropdown>
      </div>
    </div>
    <InviteUserModal v-if="showInviteModal" @close="closeInviteModal" />

  </header>
</template>
